var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("main-header", { attrs: { userProfileData: _vm.userProfileData } }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row row-flush-viewport-100" }, [
          _c(
            "div",
            {
              staticClass: "col-md-4 col-flush-viewport-left",
              attrs: { id: "search-details-enter" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  attrs: { id: "search-form-container" }
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "row no-gutters bg-white shadow-sm" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 add-scroll-y",
                            attrs: { id: "form-container", role: "main" }
                          },
                          [
                            _c(
                              "form",
                              {
                                staticClass: "needs-validation",
                                attrs: {
                                  id: "searchForm",
                                  novalidate: "",
                                  action: "self"
                                }
                              },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "px-3 py-1 border boarder-primary rounded"
                                  },
                                  [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        on: {
                                          "!mousedown": function($event) {
                                            return _vm.clearMessages(
                                              "emailOrPhone"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-xl-8 form-group"
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                attrs: { for: "emailOrPhone" }
                                              },
                                              [_vm._v("Email or Phone Number")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group",
                                                staticStyle: {
                                                  width: "95%",
                                                  "max-width": "100%"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: _vm.formData.ep,
                                                      expression: "formData.ep",
                                                      modifiers: { trim: true }
                                                    }
                                                  ],
                                                  ref: "emailOrPhone",
                                                  class: {
                                                    "form-control": true,
                                                    error: _vm.errors.has(
                                                      "emailOrPhone"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "emailOrPhone",
                                                    id: "emailOrPhone",
                                                    type: "text",
                                                    placeholder:
                                                      "Email Address / Phone Number"
                                                  },
                                                  domProps: {
                                                    value: _vm.formData.ep
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "ep",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  class: {
                                                    "fas fa-exclamation-triangle": _vm.errors.has(
                                                      "emailOrPhone"
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "emailOrPhone"
                                                    ),
                                                    expression:
                                                      "errors.has('emailOrPhone')"
                                                  }
                                                ],
                                                staticClass: "text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                  " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "emailOrPhone"
                                                      )
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass: "px-3 py-1 mt-3 border rounded"
                                  },
                                  [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c("input-product-type", {
                                      attrs: {
                                        insuranceType: _vm.insuranceType
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        on: {
                                          "!mousedown": function($event) {
                                            return _vm.clearMessages("zipcode")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-lg col-xl-10 form-group w-75"
                                          },
                                          [
                                            _vm._m(4),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group",
                                                staticStyle: {
                                                  width: "35%",
                                                  "max-width": "100%"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "digits:5",
                                                      expression: "'digits:5'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.formData.zip,
                                                      expression: "formData.zip"
                                                    },
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "#####",
                                                      expression: "'#####'"
                                                    }
                                                  ],
                                                  ref: "zipcode",
                                                  staticClass:
                                                    "std-width form-control",
                                                  class: {
                                                    "form-control": true,
                                                    error: _vm.errors.has(
                                                      "zipcode"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "zipcode",
                                                    id: "zipcode",
                                                    type: "text",
                                                    disabled:
                                                      _vm.showEpicBehaviors,
                                                    maxlength: "5",
                                                    size: "5"
                                                  },
                                                  domProps: {
                                                    value: _vm.formData.zip
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "zip",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  class: {
                                                    "fas fa-exclamation-triangle": _vm.errors.has(
                                                      "zipcode"
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "zipcode"
                                                    ),
                                                    expression:
                                                      "errors.has('zipcode')"
                                                  }
                                                ],
                                                staticClass: "text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "zipcode"
                                                      )
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        on: {
                                          "!mousedown": function($event) {
                                            return _vm.clearMessages("fname")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-xl-8 form-group"
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "fname" } },
                                              [_vm._v("First Name")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group",
                                                staticStyle: {
                                                  width: "95%",
                                                  "max-width": "100%"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        regex: /^[a-zA-Z-' ]+$/
                                                      },
                                                      expression:
                                                        "{ regex: /^[a-zA-Z-' ]+$/ }"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.formData.fname,
                                                      expression:
                                                        "formData.fname"
                                                    }
                                                  ],
                                                  ref: "fname",
                                                  class: {
                                                    "form-control": true,
                                                    error: _vm.errors.has(
                                                      "fname"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "fname",
                                                    id: "fname",
                                                    disabled:
                                                      _vm.showEpicBehaviors,
                                                    "aria-describedby":
                                                      "help-fname",
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value: _vm.formData.fname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "fname",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  class: {
                                                    "fas fa-exclamation-triangle": _vm.errors.has(
                                                      "fname"
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "fname"
                                                    ),
                                                    expression:
                                                      "errors.has('fname')"
                                                  }
                                                ],
                                                staticClass: "text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.errors.first("fname")
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(5)
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        on: {
                                          "!mousedown": function($event) {
                                            return _vm.clearMessages("lname")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-xl-8 form-group"
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "lname" } },
                                              [_vm._v("Last Name")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group",
                                                staticStyle: {
                                                  width: "95%",
                                                  "max-width": "100%"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        regex: /^[a-zA-Z-' ]+$/
                                                      },
                                                      expression:
                                                        "{ regex: /^[a-zA-Z-' ]+$/ }"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.formData.lname,
                                                      expression:
                                                        "formData.lname"
                                                    }
                                                  ],
                                                  ref: "lname",
                                                  class: {
                                                    "form-control": true,
                                                    error: _vm.errors.has(
                                                      "lname"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "lname",
                                                    id: "lname",
                                                    disabled:
                                                      _vm.showEpicBehaviors,
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value: _vm.formData.lname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "lname",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  class: {
                                                    "fas fa-exclamation-triangle": _vm.errors.has(
                                                      "lname"
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "lname"
                                                    ),
                                                    expression:
                                                      "errors.has('lname')"
                                                  }
                                                ],
                                                staticClass: "text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.errors.first("lname")
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        on: {
                                          "!mousedown": function($event) {
                                            return _vm.clearMessages(
                                              "dob_masked"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-lg col-xl-10 form-group w-75"
                                          },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "dob_masked" } },
                                              [_vm._v("Date of Birth")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group",
                                                staticStyle: {
                                                  width: "43%",
                                                  "max-width": "100%"
                                                }
                                              },
                                              [
                                                _c("the-mask", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "date_format:MM/DD/YYYY|within_year_range:108,16,MM/DD/YYYY",
                                                      expression:
                                                        "'date_format:MM/DD/YYYY|within_year_range:108,16,MM/DD/YYYY'"
                                                    }
                                                  ],
                                                  ref: "dob",
                                                  class: {
                                                    "std-width form-control": true,
                                                    error: _vm.errors.has("dob")
                                                  },
                                                  attrs: {
                                                    name: "dob_masked",
                                                    id: "dob_masked",
                                                    type: "text",
                                                    placeholder: "MM/DD/YYYY",
                                                    mask: "##/##/####",
                                                    size: "10",
                                                    masked: true
                                                  },
                                                  model: {
                                                    value: _vm.formData.dob,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "dob",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "formData.dob"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: false,
                                                      expression: "false"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "date_format:MM/DD/YYYY|within_year_range:108,16,MM/DD/YYYY",
                                                      expression:
                                                        "'date_format:MM/DD/YYYY|within_year_range:108,16,MM/DD/YYYY'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dob_masked_input_value,
                                                      expression:
                                                        "dob_masked_input_value"
                                                    }
                                                  ],
                                                  class: {
                                                    "form-control": true,
                                                    error: _vm.errors.has("dob")
                                                  },
                                                  attrs: {
                                                    name: "dob",
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dob_masked_input_value
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.dob_masked_input_value =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  class: {
                                                    "fas fa-exclamation-triangle": _vm.errors.has(
                                                      "dob"
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "dob"
                                                    ),
                                                    expression:
                                                      "errors.has('dob')"
                                                  }
                                                ],
                                                staticClass: "text-danger"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.errors.first("dob")
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.createQuoteErrs.length,
                                        expression: "createQuoteErrs.length"
                                      }
                                    ],
                                    staticClass: "small my-3 p-2 form-error"
                                  },
                                  _vm._l(_vm.createQuoteErrs, function(
                                    errData,
                                    ekey
                                  ) {
                                    return _c("span", { key: ekey }, [
                                      _c("strong", [_vm._v("Error:")]),
                                      _vm._v(" " + _vm._s(errData.Message))
                                    ])
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.custom_error_message
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "small my-3 p-2 form-error"
                                      },
                                      [
                                        _c("span", [
                                          _c("strong", [_vm._v("Error:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.custom_error_message)
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group mt-3",
                                    attrs: { id: "form-button-container" }
                                  },
                                  [
                                    _vm.showEpicBehaviors
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success d-inline-block mr-3 epic-submit",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.epicSubmit($event)
                                              }
                                            }
                                          },
                                          [_vm._v("Continue Epic Quote")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary d-inline-block mr-3",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.findQuote($event)
                                          }
                                        }
                                      },
                                      [_vm._v("Find Quote")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-primary d-inline-block mr-3",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.submitted($event)
                                          }
                                        }
                                      },
                                      [_vm._v("New Quote")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "d-inline-block mt-2" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "d-inline-block smaller-font-content qrp-text-link",
                                            attrs: {
                                              href: "JavaScript:void(0);",
                                              id: "clear-search"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.resetForm($event)
                                              }
                                            }
                                          },
                                          [_vm._v("Clear Search Fields")]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row mt-3" },
                                  [
                                    _c("main-footer", {
                                      attrs: {
                                        id: "main-footer",
                                        role: "contentinfo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 col-flush-viewport-right" }, [
            _c(
              "div",
              {
                staticClass: "row no-gutters bg-white shadow-sm",
                attrs: { id: "search-results-list" }
              },
              [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { id: "search-results-stick-body" } },
                  [
                    _vm.showEmptyMsg
                      ? _c("div", { staticClass: "pt-3 w-100" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "qrp-text-muted text-center smaller-font-content"
                            },
                            [_vm._v(_vm._s(_vm.zeroRecMsg))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.searchResultData.data, function(sItem, sKey) {
                      return !_vm.showEmptyMsg
                        ? _c(
                            "div",
                            {
                              key: sKey,
                              staticClass: "col-12 pb-0 mb-row-custom pl-0",
                              class: {
                                "row-auto-bg": sItem.ProductTypeId === 1,
                                "row-home-bg": sItem.ProductTypeId === 21,
                                "row-condo-bg": sItem.ProductTypeId === 18,
                                "row-renter-bg": sItem.ProductTypeId === 12,
                                "row-home-auto-bundle-bg":
                                  _vm.getFlowType(sItem) === "bundle",
                                "row-condo-auto-bundle-bg":
                                  _vm.getFlowType(sItem) === "cabundle",
                                "row-renter-auto-bundle-bg":
                                  _vm.getFlowType(sItem) === "rabundle"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row mx-0 smaller-font-content"
                                },
                                [
                                  sItem.ProductTypeId === 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common auto px-0"
                                        },
                                        [_vm._m(7, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sItem.ProductTypeId === 21
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common home px-0"
                                        },
                                        [_vm._m(8, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sItem.ProductTypeId === 18
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common condo px-0"
                                        },
                                        [_vm._m(9, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sItem.ProductTypeId === 12
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common renter px-0"
                                        },
                                        [_vm._m(10, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getFlowType(sItem) === "bundle"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common home-auto-bundle px-0"
                                        },
                                        [_vm._m(11, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getFlowType(sItem) === "cabundle"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common condo-auto-bundle px-0"
                                        },
                                        [_vm._m(12, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getFlowType(sItem) === "rabundle"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 py-5 mx-w-ico search-row-common renter-auto-bundle px-0"
                                        },
                                        [_vm._m(13, true)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-3 pt-4 col-lg-3 text-wrap"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              sItem.FirstName +
                                                " " +
                                                sItem.LastName
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(sItem.Email))]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "P. " +
                                            _vm._s(
                                              _vm.formatPhoneNumber(
                                                sItem.PhoneNumber
                                              )
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.ucWords(sItem.City)) +
                                            ", " +
                                            _vm._s(
                                              sItem.State + " " + sItem.ZipCode
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-3 pt-4 col-lg-2" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getProductName(sItem)) +
                                              " Insurance"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getDateFormat(
                                              sItem.LastAccessedDate
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "qrp-text-muted" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.getDayDifference(
                                                  sItem.LastAccessedDate
                                                )
                                              ) +
                                              " Days Ago)"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("br")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-3 pt-4 col-lg-2" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(sItem.CustomerProviderName)
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-2 pt-4 col-lg-2" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(sItem.ProgressDisplayValue)
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col pt-4 py-md-3 align-middle text-center"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.processQuote(
                                                { qId: sItem.SessionId },
                                                sItem
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Open Quote")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.epicSuccess
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-success alert-dismissible fade show epic-success",
              attrs: { role: "alert" }
            },
            [_vm._m(14)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.epicFailure
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-danger alert-dismissible fade show epic-failure",
              attrs: { role: "alert" }
            },
            [_vm._m(15)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.epicSubmitFailure
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-danger alert-dismissible fade show epic-failure",
              attrs: { role: "alert" }
            },
            [_vm._m(16)]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 py-1 pl-3 bg-primary text-white" },
      [_c("h1", [_vm._v("Find or Start a New Quote")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex justify-content-center mx-auto my-3 w-100" },
      [
        _c(
          "div",
          {
            staticClass: "alert alert-warning  w-100",
            attrs: { role: "note" }
          },
          [
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "d-inline-block pr-2" }, [
                _c("img", {
                  attrs: {
                    width: "20px",
                    height: "20px",
                    src: require("../assets/exclamation-circle-yellow-new.svg"),
                    alt: "info"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col d-inline-block my-auto smaller-font-content"
                },
                [
                  _c("p", { staticClass: "mb-0 text-dark-gray" }, [
                    _c("strong", [
                      _vm._v(
                        "Prior to gathering information from the customer, please read the following statement:"
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      '"I’ll be submitting your information to insurance carriers I represent who will provide you with a notice describing their privacy policies and practices once an insurance policy has been established."'
                    )
                  ])
                ]
              )
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "legend",
      { staticClass: "px-1 mb-0 w-auto text-primary smaller-font-content" },
      [
        _c("div", { attrs: { role: "heading", "aria-level": "3" } }, [
          _c("strong", [_vm._v("FIND")]),
          _vm._v(" Quotes & Policies")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "legend",
      { staticClass: "px-1 mb-0 w-auto smaller-font-content" },
      [
        _c("div", { attrs: { role: "heading", "aria-level": "3" } }, [
          _c("strong", [_vm._v("OR")]),
          _vm._v(" Find/Start A Quote "),
          _c("span", { staticClass: "qrp-text-muted" }, [
            _vm._v("("),
            _c("span", { staticClass: "star" }, [_vm._v("*")]),
            _vm._v("Required for new quotes.)")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "zipcode" } }, [
      _vm._v("Zip Code"),
      _c("span", { staticClass: "star" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "form-text qrp-text-muted smaller-font-content",
        attrs: { id: "help-fname" }
      },
      [
        _vm._v(
          "Must be used with\n                                                    "
        ),
        _c("strong", [_vm._v("Last Name")]),
        _vm._v(".")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "search-results-stick-head-columns" } }, [
      _c(
        "div",
        { staticClass: "col-12 py-1 bg-primary text-white text-center" },
        [_c("h1", [_vm._v("Search Results")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-12 pt-2 pb-1 bg-white pl-0",
          staticStyle: { "border-bottom": "1px solid #ebebeb" },
          attrs: { id: "search-results-list-header" }
        },
        [
          _c(
            "div",
            { staticClass: "row mx-0 smaller-font-content font-weight-bold" },
            [
              _c("div", { staticClass: "col-1 mx-w-ico text-center" }, [
                _c("span", { staticClass: "fas fa-archive" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 col-lg-3" }, [
                _c("span", [_vm._v("Named Insured")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 col-lg-2" }, [
                _c("span", [_vm._v("Quote")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 col-lg-2" }, [
                _c("span", [_vm._v("Provider")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-2 col-lg-2" }, [
                _c("span", [_vm._v("Progress")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" })
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [_c("span", { staticClass: "fas fa-car" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [_c("span", { staticClass: "fas fa-home" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [_c("span", { staticClass: "fas fa-hotel" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [_c("span", { staticClass: "fas fa-building" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "fas fa-home-auto-bundle-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "fas fa-condo-auto-bundle-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "fas fa-renter-auto-bundle-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-inline-block float-left align-self-center mx-2 text-center"
        },
        [_c("span", { staticClass: "fas fa-check-circle epic-alert-icon" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col px-0 d-inline-block" }, [
        _c("h4", [_vm._v("Success: Customer Information Prefilled!")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The EPIC customer's information has been prefilled. Proceed with the “Continue w/ EPIC Quote” button."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-inline-block float-left align-self-center mx-2 text-center"
        },
        [
          _c("span", {
            staticClass: "fas fa-exclamation-circle epic-alert-icon"
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col px-0 d-inline-block" }, [
        _c("h4", [_vm._v("Error: Customer Information Prefill Failed!")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The customer information was not prefilled. Please try again by going back to EPIC, or proceed with a new quote."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-inline-block float-left align-self-center mx-2 text-center"
        },
        [
          _c("span", {
            staticClass: "fas fa-exclamation-circle epic-alert-icon"
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col px-0 d-inline-block" }, [
        _c("h4", [_vm._v("Error: Customer Quote Import Failed!")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The customer quote information was not imported. Please try again by using the “Continue w/ EPIC Quote” button."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-412e65f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-412e65f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/Search.vue
// module id = null
// module chunks = 